import { useEffect } from 'react';

const useScript = (url: string, onLoad: () => void) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = () => onLoad();
    document.body.appendChild(script);
    return () => {
      script.remove();
    };
  }, [url]);
};

export default useScript;
